<template>
  <div class="originality1">
    <div class="copywriting1">
      <div class="copywriting1_titleArea">
        <h3 class="title">创意内容</h3>
      </div>
      <div class="copywriting1_main">
        <div class="main_item">
          <div class="item_title">
            <span class="title">广告样式</span>
          </div>
          <div class="item_mian">
            <el-radio
              v-model="creativeStyle"
              label="1"
            >常规广告</el-radio>
          </div>
        </div>

        <div class="main_item">
          <div class="item_title">
            <span class="title">样式类型</span>
          </div>
          <div class="item_mian">
            <el-radio
              v-model="creativeStyle"
              label="1"
            >常规广告</el-radio>
          </div>
          <!-- <div class="item_main">
            <el-button
              plain
              @click="isMantle = 'popup'"
            >上传图片</el-button>
            <p class="main_tips">请上传右图所示广告位图片<br>
              图片大小为465*230像素，支持bmp, png, jpeg, jpg格式，不超过30KB</p>
            <div
              v-if="img"
              class="imageBox"
            >
              <img
                class="iamgeBox_img"
                :src="img.path"
              >
              <p class="imageBox_p">
                <i class="icon" />
              </p>
            </div>
          </div> -->
        </div>

        <div class="main_item">
          <div class="item_title">
            <span class="title">外层文案</span>
          </div>
          <div class="item_mian">
            <el-input
              v-model="obj.textarea"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              maxlength="40"
              placeholder="请输入内容"
              show-word-limit
              @input="outercopy"
            />
          </div>
        </div>
        <div class="main_item">
          <div class="item_title">
            <span class="title">外层素材跳转</span>
          </div>
          <div class="item_mian">
            <el-radio
              v-model="creativeStyle"
              label="1"
            >原生推广页</el-radio>
          </div>
        </div>
        <div class="main_item">
          <div class="item_title">
            <span class="title" />
          </div>
          {{ name }}
          <div v-if="type ==='edit2' || type ==='edit3'" class="item_mian" @click="chooseyuan">
            <div>选择原生推广页</div>
          </div>
        </div>

        <div class="main_item">
          <div class="item_title" style="width:240px">
            <span class="title">文字链文案</span>
          </div>
          <div class="item_main">
            <el-radio
              v-for="item,index in copywritingarr"
              :key="index"
              v-model="obj.link_name"
              :label="item.text"
              @change="copyclick"
            >{{ item.text }}</el-radio>
          </div>
        </div>
        <div class="main_item">
          <div class="item_title">
            <span class="title">文字链跳转</span>
          </div>
          <div class="item_main">
            <el-radio
              v-model="creativeStyle"
              label="1"
            >原生页推广</el-radio>
          </div>
        </div>
        <!-- <div class="main_item">
          <div class="item_title">
            <span class="title">原生推广页</span>
          </div>
          <div class="item_main">
            <span>原生推广页20220219160639</span>
            <span @click="isMantle = 'PrimaryPromotion'">更改</span>
          </div>
        </div> -->
      </div>

    </div>

    <div class="originality1_right">
      <div class="right_top">
        <div class="top1">
          <h3 class="title">创意预览</h3>
          <span class="text">最终效果以实际展现为准</span>
        </div>
      </div>
      <div class="right_box1">
        <ul class="right_box">
          <li
            class="item"
            :class="{active:preview==='quterLayer'}"
            @click="preview = 'quterLayer'"
          >外层</li>
          <li
            class="item"
            :class="{active:preview === 'promotionPage'}"
            @click="preview = 'promotionPage'"
          >推广页</li>
          <li
            class="item"
            :class="{active:preview === 'share'}"
            @click="preview = 'share'"
          >分享</li>
        </ul>
      </div>
    </div>

    <div
      v-if="isMantle"
      class="Mantle"
    >
      <Popup
        v-if="isMantle === 'popup'"
        @close="isMantle = false"
        @determine="determine"
        @rule="rule"
      />
      <PrimaryPromotion v-else-if="isMantle === 'PrimaryPromotion'" @close="isMantle = false" />
    </div>

    <div>
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <el-table
          v-loading="loading"
          :data="publicDirectionList"
          style="width: 100%"
        >
          <el-table-column
            :key="refreshKey"
            label="选项"
            width="100"
          >
            <template scope="scope">
              <div v-if="scope.row.check_type === 0" class="nocheck" />

              <input v-else v-model="scope.row.checkboxFlag" type="checkbox" @click="handleChangeSelect(scope.$index, scope.row)">
              {{ scope.row.$index }}
            </template>
          </el-table-column>
          <el-table-column
            prop="canvas_name"
            label="原生页名称"
            width="180"
          />
          <el-table-column
            prop="page_id"
            label="原生页ID"
            width="140"
          />
        </el-table>
        <el-button type="primary" @click="quedngbtn">确定</el-button>
      </el-dialog>
    </div>
  </div>

</template>

<script>
import Popup from '@/views/newNativePromotionPage/components/popup/index1.jsx'
import PrimaryPromotion from '../components/PrimaryPromotion.vue'
import { /* getMaterialList ,*/ getMaterialList1 } from '@/api/nativePAGE.js'
import { getNativepage /* getPromotionplan,  createAdGroup , createAdvertisingPlan, createAdvertisingIdeas*/ } from '@/api/legacyPlan.js'
// import QuterLayer from './quterLayer.vue'
export default {
  components: {
    // QuterLayer,
    Popup,
    PrimaryPromotion
  },
  props: {
    clickJump1: {},
    buttonJump1: {},
    creativeobj: {},
    yuanshengname: {}
  },
  data() {
    return {
      name: '',
      dialogVisible: false,
      loading: false,
      obj: {
        textarea: '', // 文本域文字绑定
        link_name: '' // 文字链文案绑定的值
      },

      copywritingarr: [{
        text: '了解更多'
      }, {
        text: '去逛逛'
      }, {
        text: '查看详情'
      }, {
        text: '立即体验'
      }, {
        text: '立即咨询'
      }, {
        text: '立即开通'
      }, {
        text: '立即抢购'
      },
      {
        text: '立即申请'
      },
      {
        text: '立即秒杀'
      },
      {
        text: '立即购买'
      },
      {
        text: '立即预定'
      },
      {
        text: '立即预约'
      },
      {
        text: '立即领取'
      },
      {
        text: '观看直播'
      },
      {
        text: '进入小程序'
      },
      {
        text: '领取优惠'
      }], // 文字链文案数组

      creativeStyle: '1', // 单选的默认选项
      refreshKey: 0,
      publicDirectionList: [],
      preview: 'quterLayer',
      isMantle: false,
      img: null,
      yuanshengtype: null, // 原生页的type值

      type: '',
      nativepagejson: {
        share_title: '',
        share_desc: '',
        share_thumb: '',
        canvas_type: null,
        canvas_info: null,
        page_id: null
      }
    }
  },
  created() {
    // 获取可以显示原生页推广吗
    this.type = sessionStorage.getItem('newtype')
    // 获取原生页类型
    console.log(sessionStorage.getItem('product'))
    if (sessionStorage.getItem('product') === 'PRODUCTTYPE_WECHAT_ARTICLE') {
      this.yuanshengtype = 1
    }
    if (sessionStorage.getItem('product') === 'PRODUCTTYPE_LEAD_AD') {
      this.yuanshengtype = 2
    }
    if (sessionStorage.getItem('product') === 'PRODUCTTYPE_WECHAT') {
      this.yuanshengtype = 3
    }
    this.getdata()

    this.onloadData()
  },
  methods: {
    // checkbox单选效果
    handleChangeSelect(index) {
      if (this.publicDirectionList[index].check_type === 0) {
        return
      }

      if (!this.publicDirectionList[index].checkboxFlag) {
        this.name = this.publicDirectionList[index].canvas_name
        // 回传json
        this.$emit('jsonyuansheng', this.publicDirectionList[index])
        // 回传原生页名字
        this.$emit('setyuanshengname', this.publicDirectionList[index].canvas_name)
      } else {
        this.name = ''
        // 回传json
        this.$emit('jsonyuansheng', this.nativepagejson)
        // 回传原生页名字
        this.$emit('setyuanshengname', '')
      }
      this.publicDirectionList.forEach(item => {
        item.checkboxFlag = false
      })
      this.publicDirectionList[index].checkboxFlag = true
      this.refreshKey = Math.random()
    },
    // 获取原生页列表数据
    getdata() {
      console.log('this.yuanshengname', this.yuanshengname)
      this.loading = true
      getNativepage({
        type: this.yuanshengtype,
        page_size: 20
      }).then(res => {
        this.publicDirectionList = res.data.list
        this.publicDirectionList.forEach(item => {
          item.checkboxFlag = false
        })
        this.finindeq()
        this.loading = false
        console.log('原生页', res)
      })
    },
    // 判断在不在
    finindeq() {
      const index = this.publicDirectionList.findIndex(item => {
        return this.yuanshengname === item.canvas_name
      })
      if (index === -1) {
        console.log('不存在')
        this.name = ''
        // 清空回传json
        this.$emit('jsonyuansheng', this.nativepagejson)
        // 清空原生页名字
        this.$emit('setyuanshengname', '')
      } else {
        this.name = this.yuanshengname// 原生页名字
        this.publicDirectionList[index].checkboxFlag = true
        console.log('存在')
      }
      // console.log('在不在', this.publicDirectionList)
    },
    // 选择原生页弹窗
    chooseyuan() {
      this.dialogVisible = true
    },
    // 初始化数据选择朋友圈数据
    onloadData() {
      console.log('传过来的值', this.creativeobj)
      this.obj.textarea = this.creativeobj.desc// 文本域文字绑定赋值
      this.obj.link_name = this.creativeobj.link_name // 文字链文案绑定赋值
    },
    // 外层文案回调
    outercopy() {
      this.$emit('creativecallback', this.obj)
    },
    // 关闭弹窗
    quedngbtn() {
      this.dialogVisible = false
    },
    // 文字链文案回调
    copyclick() {
      this.$emit('creativecallback', this.obj)
    },
    setThumbnail(event) {
      this.img = event
      this.isMantle = false
    },
    determine(select) {
      this.$emit('setOriginality', {
        adcreative_elements: {
          image: select.id
        }
      })
    },
    async rule(page, Callback) {
      const data = await getMaterialList1({
        type: 1,
        page
      })
      Callback({
        type: 'img',
        total: data.data.total,
        datas: data.data.list
      })
    },
    aaa() {
      this.$emit('nextStep', this.img.id)
    }
  }
}
</script>

<style scoped lang="less">
.el-radio{
  margin-bottom: 10px;
}
.nocheck{
  width: 13px;
  height: 13px;
  background-color: #f2f6fc;
  border-color: #dcdfe6;
  position: relative;
      cursor: no-drop;
}
.nocheck::after{
  box-sizing: content-box;
    content: "";
    border: 1px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 7px;
    left: 4px;
    position: absolute;
    top: 1px;
    transform: rotate(45deg) scaleY(0);
    width: 3px;
    transition: transform .15s ease-in .05s;
    transform-origin: center;
  transform: rotate(45deg) scaleY(1);
  border-color: #c0c4cc;
}
.originality1 {
  width: 100%;
  display: flex;
  .originality1_right {
    width: 30%;
    padding: 16px 0px 40px;
    color: #24262e;
    background-color: #fff;
    border-radius: 3px;
    position: relative;
    margin-bottom: 8px;
    margin-left: 17px;
    .right_top {
      margin-bottom: 12px;
      padding-right: 24px;
      padding-bottom: 12px;
      padding-left: 24px;
      box-shadow: 0 1px 0 0 rgb(0 0 0 / 6%);
      .top1 {
        .title {
          font-size: 14px;
          line-height: 24px;
          color: rgb(31, 31, 31);
          font-weight: 600;
        }
        .text {
          display: flex;
          align-items: center;
          font-size: 12px;
          line-height: 26px;
          color: rgb(163, 163, 163);
        }
      }
    }
    .right_box1 {
      text-align: center;
      border-bottom: 1px solid #e3e4e6;
      height: 30px;
      padding: 0px 24px;
      .right_box {
        width: 100%;
        height: 100%;
        display: flex;
        font-size: 13px;
        justify-content: space-between;
        .item {
          cursor: pointer;
          position: relative;
          &.active {
            color: #07c160;
            &::before {
              content: '';
              width: 100%;
              height: 2px;
              background-color: #07c160;
              position: absolute;
              top: 96%;
            }
          }
        }
      }
    }
  }
}
.imageBox {
  width: 100px;
  height: 100px;
  position: relative;
  margin-top: 10px;
  .iamgeBox_img {
    width: 100%;
    height: 100%;
  }
  .imageBox_p {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 22px;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAYAAACEnoQPAAAAAXNSR0IArs4c6QAAAFVJREFUOBFjYKAAMGLTu2nTpv/o4n5+fhhqmdAVkcJnxGYLsQZQZjPMFlJcAPM/VpthkjCD0fkwcayaYZKE6FHNhEIITX7gAgyeU6iWwtC8hpNLkZ8BrAkRCnd2mTMAAAAASUVORK5CYII=);
      width: 15px;
      height: 18px;
      cursor: pointer;
    }
  }
}
.copywriting1 {
  width: 70%;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 0 0 1px hsl(0deg 0% 87% / 50%), 0 3px 6px 0 rgb(0 0 0 / 4%);
  margin-bottom: 8px;
  .copywriting1_titleArea {
    box-shadow: rgb(0 0 0 / 6%) 0px 1px 0px 0px;
    padding: 16px 16px 20px 24px;
    .title {
      color: #1f1f1f;
      font-weight: 600;
      word-wrap: break-word;
      font-size: 14px;
    }
  }

  .copywriting1_main {
    padding: 28px 0px;
    .main_item {
      margin: 0px 20px;
      margin-bottom: 28px;
      display: flex;
      .item_title {
        width: 110px;
        .title {
        }
      }
      .item_main {
        .main_tips {
          color: #828282;
          font-size: 12px;
          line-height: 1.3;
        }
      }
    }
  }
}
.Mantle {
  position: fixed;
  z-index: 1111;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}
</style>
